import React from 'react'
import { Input } from 'semantic-ui-react'

interface OptionalInputProps {
  isEditing: boolean
  onClick: () => void
  onChange: (x: string) => void
  inputName: string
  value: string
}

const OptionalInput = (props: OptionalInputProps) => {
  const { inputName, isEditing, onClick, onChange } = props
  return (
    <Input
      action={{
        color: 'teal',
        content: !isEditing ? `Edit ${inputName}` : 'Cancel edit ',
        icon: isEditing ? 'cancel' : 'pencil',
        labelPosition: 'left',
        onClick: () => onClick(),
      }}
      actionPosition="left"
      disabled={!isEditing}
      id={`optional-input-${inputName.replace(' ', '_')}`}
      label={{ tag: true, content: inputName }}
      labelPosition="right"
      onChange={(e) => onChange(e.target.value)}
      size="massive"
      style={{
        marginTop: '30px',
      }}
      value={props.value}
    />
  )
}

export default OptionalInput
